import React from 'react';
import styles from '../styles.module.css';

// Horizontal toolbar divider.
const ToolbarHDivider = () => {
  return <div className={styles.toolHDivider}></div>;
};

export default ToolbarHDivider;
